export default __webpack_public_path__ + "static/media/mob_2.9b842794.png";